
define('text!common/views/commercial/creatives/logo-about.html',[],function () { return '<a href="<%=clickMacro%><%=infoUrl%>" class="ad-slot--paid-for-badge__help">About this content</a>\n';});

